<template>
  <div class="text-xs-center" >
    <v-dialog
      v-model="dialog"
      persistent
      width="300"
    >
      <v-card
        color="#39a9dc"
        dark
      >
        <v-card-text>
          <v-layout justify-center>
          <flower-spinner
                v-if="message" 
                :animation-duration="1500"
                :size="20"
                :color="'white'"
                style="float:left;margin-right:10px"
          />
          <span 
            v-if="message" 
            style="float:left">{{message}}</span>
          </v-layout>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions v-if="button">
          <v-spacer>
          </v-spacer>
            <v-btn class="ma-2"  flat v-on:click="$emit('clicked')">
                {{button}}
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {FlowerSpinner} from 'epic-spinners'
export default {
  
  props:{
    dialog: Boolean,
    message: String,
    button: String
  },
  components: {
      FlowerSpinner
  }

}
</script>